
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import DeleteDialog from '@/components/uicomp/ModalDialog-Delete'
import TableOptionsDialog from './ListOptionsDialog'
const components = {
  DeleteDialog,
  TableOptionsDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  list: `Product/Service/list`,
  meta: `Product/Service/listMeta`,
})

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Product/Service/setListOption`,
  reload: `Product/Service/fetchList`,
  pagePrev: `Product/Service/pagePrev`,
  pageNext: `Product/Service/pageNext`,
  deleteItem: `Product/Service/remove`,
  updateData: `Product/Service/update`,
})

methods.edit = function (id) {
  this.$router.push(`/product/service/${id}`)
}

methods.editValue = function (id, property, value) {
  this.updateData({
    id,
    data: { [property]: value },
  })
}

methods.showopt = function () {
  this.$refs.TableOptionsDialog.show()
}

methods.search = function (value) {
  this.setListOption({ search: value })
}

/**
 * Watch
 *
 */
const watch = {
  meta: {
    deep: true,
    handler(n, o) {
      n.version !== o.version && this.reload()
    },
  }
}

/**
 * Event OnMounted
 *
 */
const mounted = async function() {
  this.setListOption({ format: `deep` })
}

/**
 * Event OnCreated
 *
 */
const created = async function() {
  //
}

/**
 * Event Socket
 *
 */
const sockets = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
  mounted,
  created,
  sockets,
}
</script>

<style scoped>
  .bg-green {
    background-color: #80ef7324;
  }
  .bg-orange {
    background-color: #f1bd6e40;
  }
</style>

<template>
  <Row>
    <TableOptions
      :nrecord="meta.nrecord"
      :npage="meta.npage"
      :curpage="meta.curpage"
      :searchValue="meta.filter.search"
      @nextpage="pageNext"
      @prevpage="pagePrev"
      @showopt="showopt"
      @search="search"
    />
    <TableOptionsDialog ref="TableOptionsDialog"
    />

    <TableList>
      <template #head>
        <th width="40" class="text-center">#</th>
        <th class="text-left">Layanan</th>
        <th width="80" class="text-right">Jasa <br>Teknisi</th>
        <th width="80" class="text-right">HJ.<br>ke Plg</th>
        <th width="80" class="text-right">HJ.<br>ke Toko</th>
        <!-- <th width="80" class="text-right">Komisi Reseller</th> -->
        <th width="40" class="text-right"></th>
      </template>

      <template #body>
        <tr v-for="(item, index) in list" :key="item.id">
          <td class="text-center" v-html="index + meta.curstart"></td>
          <td class="text-left">
            <router-link class="link underlined" :to="`/product/service/${item.id}`">
              {{ item.name }}
            </router-link>
            <p class="subdata">{{ item.description }}</p>
          </td>
          <td class="text-right">
            <TextFieldChangable
              allow="0-9"
              :forceupper=true
              :value="item.worker_commission_readable"
              @submit="editValue(item.id, `worker_commission`, $event)"/>
          </td>
          <td class="text-right bg-green">
            <TextFieldChangable
              allow="0-9"
              :forceupper=true
              :value="item.price_unit_readable"
              @submit="editValue(item.id, `price_unit`, $event)"/>
          </td>
          <td class="text-right bg-orange">
            <TextFieldChangable
              allow="0-9"
              :forceupper=true
              :value="item.price_store_readable"
              @submit="editValue(item.id, `price_store`, $event)"/>
          </td>
          <!-- <td class="text-right">
            <TextFieldChangable
              allow="0-9"
              :forceupper=true
              :value="item.resell_commission_readable"
              @submit="editValue(item.id, `resell_commission`, $event)"/>
          </td> -->
          <td class="text-right">
            <TButtonDelete @click="$refs.DeleteDialog.confirm(item.id, item.name)" />
          </td>
        </tr>
      </template>
    </TableList>

    <DeleteDialog ref="DeleteDialog" @submit="deleteItem($event)" />
  </Row>
</template>